import React from 'react';
import { Spinner } from '../Spinner/Spinner';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'tertiary';
  inverse?: boolean;
  size?: 'default' | 'small';
  textSize?: 'default' | 'large';
  loading?: boolean;
  fullWidth?: boolean;
  /** Renders as <a> tag when provided */
  href?: string;
  loaderReplacesContent?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  inverse = false,
  size = 'default',
  textSize = 'default',
  loading = false,
  fullWidth = false,
  href,
  loaderReplacesContent = false,
  disabled,
  children,
  className = '',
  ...rest
}) => {
  const classes = [
    'dyn-bt',
    `dyn-bt-${variant}`,
    inverse && 'dyn-bt-inverse',
    size === 'small' && 'dyn-bt-small',
    textSize === 'large' && 'dyn-bt-large-text',
    fullWidth && 'dyn-bt-full-width',
    loading && 'dyn-bt-loading',
    className,
  ].filter(Boolean).join(' ');

  if (href) {
    return (
      <a href={href} className={classes}>
        {children}
      </a>
    );
  }

  return (
    <button
      className={classes}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading && <Spinner size="small" />}
      {(!loading || !loaderReplacesContent) && children}
    </button>
  );
};
